const ContentWraper = ({ children }: any) => {
  return <div className='bg-white rounded-lg shadow-md my-7 p-10'>{children}</div>
}

export default ContentWraper
